import React from "react";
import ReactDOM from "react-dom";
import { motion } from "framer-motion";
import {
  modalHeightVariants,
  modalVariants,
} from "../../animation/RoutesAnimations";

interface VideoModalProps {
  onShowModalChange: (newShowModalState: boolean) => void;
  telNumber: number;
}

const VideoModal: React.FC<VideoModalProps> = ({ onShowModalChange }) => {
  const VideoEmbed = ({ src }: any) => {
    return (
      <object
        className="absolute top-0 left-0 w-full h-full rounded-md"
        data={src}
        type="text/html"
        width="100%"
        height="100%"
        title="وامسی | vam30"
      >
        Your browser does not support embedding this video.
      </object>
    );
  };

  return ReactDOM.createPortal(
    <>
      <motion.div
        variants={modalVariants}
        initial="initial"
        animate="final"
        id="static-modal"
        data-modal-backdrop="static"
        tabIndex={-1}
        aria-hidden="true"
        className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-screen bg-gray-500 bg-opacity-50"
      >
        <motion.div
          layout
          variants={modalHeightVariants}
          initial="initial"
          animate="final"
          className={`relative w-[400px] overflow-hidden bg-white rounded-lg shadow pb-4 px-4 `}
        >
          <motion.div
            layout={"position"}
            initial="initial"
            animate="final"
            className="relative "
          >
            <div className="w-full pl-4 pt-2 flex items-center justify-between">
              <span className="invisible">Close modal</span>
              <svg
                className="w-3 h-3 hover:cursor-pointer"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
                onClick={() => onShowModalChange(false)}
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
            </div>
            <div className="grid  mt-5 items-center justify-center">
              <div className="w-full flex flex-col">
                <div className="relative  flex-col">
                  <span className="block pb-[57%]"></span>
                  <VideoEmbed
                    src={
                      "https://www.aparat.com/video/video/embed/videohash/xqp2rzm/vt/frame?titleShow=true&muted=true"
                    }
                  />
                </div>
                <div className="flex mt-5 md:mt-1 mx-auto text-BodyText/16/Bold min-h-16 whitespace-nowrap">
                  چگونه در سامانه وامسی ثبت سفارش کنیم؟
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </motion.div>
    </>,
    document.getElementById("modal-root")!
  );
};

export default VideoModal;
